import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CentralFileExchangeService {
  private readonly http = inject(HttpClient);

  // eop.fe->R-download-file->iss.cfe
  downloadFileFromCFE(
    downloadId: string,
    fileName: string,
    unsubscribe$: Observable<void>,
    successHandler?: (blob: Blob) => void,
    errorHandler?: (error: any) => void
  ): void {
    this.http
      .get<Blob>(`${environment.baseCfeUrl}/files/download/${downloadId}`, {
        responseType: 'blob' as 'json',
        observe: 'body',
      })
      .pipe(takeUntil(unsubscribe$))
      .subscribe({
        next: (blob: Blob) => {
          this.downloadFile(blob, fileName);
          successHandler ? successHandler(blob) : null;
        },
        error: error => (errorHandler ? errorHandler(error) : null),
      });
  }

  private downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }
}
